import { render, staticRenderFns } from "./CloseTasksChart.vue?vue&type=template&id=a0a15442&scoped=true&"
import script from "./CloseTasksChart.vue?vue&type=script&lang=js&"
export * from "./CloseTasksChart.vue?vue&type=script&lang=js&"
import style0 from "./CloseTasksChart.vue?vue&type=style&index=0&id=a0a15442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a15442",
  null
  
)

export default component.exports